module.exports = __webpack_public_path__ + "img/transfer.bdff19f4.png";